import React, { useState } from "react";
import SettingsStyles from "./Settings.styles";
import { breadCrumbList, settingsData } from "./SettingsData";
import CustomBreadcrumb from "../../global/components/CustomBreadcrumb/CustomBreadcrumb";
import { Box, Grid, Typography } from "@mui/material";
import CustomPageHeader from "../../global/components/CustomPageHeader/CustomPageHeader";
import CustomButton from "../../global/components/CustomButton/CustomButton";
import ProfileIcon from "../../assets/icons/ph_user.svg";
import SecurityIcon from "../../assets/icons/security.svg";
import MyProfileView from "./components/MyProfileView/MyProfileView";
import Security from "./components/Security/Security";

const Settings = () => {
  const classes = SettingsStyles;
  const [cardButtonVal, setCardButtonVal] = useState<string>("");
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const handleButtonCard = (cardButtonValue: any) => {
    setCardButtonVal(cardButtonValue);
    setIsDialogOpen(true);
  };

  const handleCloseProfile = () => {
    setIsDialogOpen(false);
  };

  const getSttingsContent = () => {
    switch (cardButtonVal) {
      case "MyProfile":
        return (
          <MyProfileView
            isDialogOpen={isDialogOpen}
            handleCloseProfile={handleCloseProfile}
          />
        );
      case "Security":
        // return (
          // <Security
          //   isDialogOpen={isDialogOpen}
          //   handleCloseProfile={handleCloseProfile}
          // />
        // );
      default:
        return null;
    }
  };

  const getSettings = () => {
    return (
      <>
        <CustomBreadcrumb breadCrumbList={breadCrumbList} />
        <Box sx={classes.SettingsWrapper}>
          <CustomPageHeader
            heading="Settings"
            subInfo="View information and Manage security settings"
          />

          <Grid container spacing={2.5} mt={1}>
            {settingsData.map((item: any) => {
              return (
                <>
                  <Grid item xs={12} md={3} lg={4}>
                    <Box
                      sx={classes.card}
                      onClick={() => {
                        handleButtonCard(item.cardbuttonValue);
                      }}
                    >
                      <Box sx={classes.cardHeader}>
                        <img src={item.cardIcon} alt="" />
                      </Box>
                      <Box>
                        <Box>
                          <Typography sx={classes.cardHeadinig}>
                            {item.cardheading}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography sx={classes.cardtext}>
                            {item.cardtext}
                          </Typography>
                        </Box>
                        {/* <Box>
                          <Typography
                            onClick={(event: any) => {
                              handleButtonCard(event);
                            }}
                            sx={classes.customStyle}
                          >
                            {item.carButtonText}
                          </Typography>
                        </Box> */}
                      </Box>
                    </Box>
                  </Grid>
                </>
              );
            })}
          </Grid>
        </Box>
        {getSttingsContent()}
      </>
    );
  };

  return getSettings();
};

export default Settings;
